import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import ConfirmationCheck from '@/assets/icons/ConfirmationCheck.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseCompletePage',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const secondsLeft = ref(15)
let intervalId: number | null = null

const goToEvent = () => {
  const id = route.params.id
  router.replace({ name: 'Event', params: { id: String(id) } })
}

onMounted(() => {
  intervalId = window.setInterval(() => {
    if (secondsLeft.value <= 1) {
      if (intervalId) clearInterval(intervalId)
      goToEvent()
    } else {
      secondsLeft.value -= 1
    }
  }, 1000)
})

onBeforeUnmount(() => {
  if (intervalId) clearInterval(intervalId)
})

return { __sfc: true,route, router, secondsLeft, intervalId, goToEvent, ConfirmationCheck }
}

})